import { useEffect, useRef } from "react";
import { whyChooseUs } from "@/mocks/features";

export default function WhyUs() {
  const cardsRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("opacity-100", "translate-y-0");
            entry.target.classList.remove("opacity-0", "translate-y-8");
          }
        });
      },
      { threshold: 0.1 }
    );

    const cards = cardsRef.current?.children;
    if (cards) {
      Array.from(cards).forEach((card, index) => {
        card.classList.add("opacity-0", "translate-y-8", "transition-all", "duration-700");
        (card as HTMLElement).style.transitionDelay = `${index * 100}ms`;
        observer.observe(card);
      });
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section id="why-us" className="py-20 md:py-28 bg-white">
      <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <span className="inline-block bg-brand-50 text-brand-700 px-4 py-2 rounded-full text-sm font-semibold mb-4 border border-brand-200">
              Zašto SafeGuard
            </span>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-dark-900 mb-4">
              Vaša bezbednost je
              <br />
              <span className="text-brand-500">naša misija</span>
            </h2>
            <p className="text-dark-400 text-lg max-w-2xl mx-auto">
              Više od 15 godina iskustva, 5,000+ instalacija i tim od 50+ stručnjaka — evo zašto smo izbor broj 1
            </p>
          </div>

          <div ref={cardsRef} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 mb-16">
            {whyChooseUs.map((item, index) => (
              <div
                key={index}
                className="group p-6 md:p-8 rounded-2xl bg-dark-50 border border-dark-100 hover:border-brand-200 hover:bg-white transition-all duration-300"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-brand-50 rounded-xl mb-5 group-hover:bg-brand-500 transition-all">
                  <i className={`${item.icon} text-xl text-brand-500 group-hover:text-white transition-all`}></i>
                </div>
                <h3 className="text-base font-bold text-dark-900 mb-3">
                  {item.title}
                </h3>
                <p className="text-dark-400 text-sm leading-relaxed">
                  {item.description}
                </p>
              </div>
            ))}
          </div>

          <div className="bg-brand-600 rounded-3xl p-8 md:p-12 flex flex-col md:flex-row items-center justify-between gap-8">
            <div className="flex items-center gap-8 flex-wrap justify-center md:justify-start">
              <div className="text-center">
                <div className="text-3xl font-bold text-white">15+</div>
                <div className="text-sm text-white/70">Godina iskustva</div>
              </div>
              <div className="w-px h-12 bg-white/20 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-3xl font-bold text-white">5,000+</div>
                <div className="text-sm text-white/70">Instalacija</div>
              </div>
              <div className="w-px h-12 bg-white/20 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-3xl font-bold text-white">3 god.</div>
                <div className="text-sm text-white/70">Garancija</div>
              </div>
              <div className="w-px h-12 bg-white/20 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-3xl font-bold text-white">24/7</div>
                <div className="text-sm text-white/70">Podrška</div>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <div className="flex -space-x-3">
                {[1,2,3,4].map((i) => (
                  <div key={i} className="w-10 h-10 rounded-full bg-brand-400 border-2 border-brand-600 flex items-center justify-center">
                    <i className="ri-user-line text-white text-sm"></i>
                  </div>
                ))}
              </div>
              <span className="text-white/80 text-sm">98% zadovoljnih klijenata</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}